import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import SignUp from './components/SignUp';
import HomePage from './components/HomePage';
import ProfilePage from './components/ProfilePage';
import UserProfilePage from './components/UserProfilePage';
import Header from './components/Header';
import CreatePost from './components/CreatePost';
import EditPost from './components/EditPost';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import ScrollToTop from './components/ScrollToTop';
import SearchPage from './pages/SearchPage';
import ListPage from './components/ListPage';
import './App.css';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return currentUser ? <>{children}</> : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Header />
        <div className="app-container">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/" element={<HomePage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <ProfilePage />
                </PrivateRoute>
              }
            />
            <Route path="/profile/u/:username" element={<UserProfilePage />} />
            <Route
              path="/create-post"
              element={
                <PrivateRoute>
                  <CreatePost />
                </PrivateRoute>
              }
            />
            <Route path="/edit-post/:postId" element={<PrivateRoute><EditPost /></PrivateRoute>} />
            <Route path="/lists/:listId" element={<ListPage />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
